import { apiClient } from "@/shared/api/client";

export interface Product {
  id: string;
  name: string;
  description: string;
  price: string;
  feature: { label: string[] };
  category: string;
  status: string;
  payment_type: string;
}

export interface ProductResponse {
  success: boolean;
  data: Product[];
  message: string;
}

export async function fetchProducts(): Promise<Product[]> {
  const response = await apiClient.get<ProductResponse>("/v1/product");
  const data = response.data;

  if (data.success && Array.isArray(data.data)) {
    return data.data.filter((p) => p.status === "ACTIVE");
  }

  return [];
}
